import ThemeProviderProps from '../../../contexts/SelectedThemeContext/withSelectedTheme.attachedProps'
import NavigationMenuProps from '../../../contexts/NavigationMenuContext/withNavigationMenu.attachesPropTypes'

const FooterPropTypes = {
  ...ThemeProviderProps,
  ...NavigationMenuProps
}

export default FooterPropTypes
